import EquipmentOverview from "./EquipmentOverview";

export default EquipmentOverview;
export { EquipmentOverview };
